import { useSnackbar } from 'notistack'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { createAsyncAction, Action } from 'src/utils/reduxUtils'
import { formatApiErrorMessage } from 'src/utils/errorHandlers'

export const useAsyncDispatchWithErrorToast = () => {
  const dispatch = useDispatch()
  const snackbar = useSnackbar()

  const asyncDispatchWithErrorToast = useCallback(
    async <T, K = any>(action: Action<K>, silent?: boolean): Promise<T | null> => {
      try {
        const result = await createAsyncAction<T, K>(dispatch, action)

        return result
      } catch (err: any) {
        if (!silent) {
          const rawErrorMessage = Array.isArray(err)
            ? err
            : err?.payload?.message || err?.message || err

          const errorMessage = formatApiErrorMessage(rawErrorMessage)

          snackbar?.enqueueSnackbar(errorMessage, { variant: 'error' })
        }

        return null
      }
    },
    [],
  )

  return { asyncDispatchWithErrorToast }
}
